module.exports = __webpack_public_path__ + "static/media/paw_warning.cc39a0d0.svg";